import '../App.css';
import {css} from "@emotion/css";
import {Button, Card, CardContent, Divider, Grid, List, ListItem, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {useEffect} from "react";


export default function Services() {
    useEffect(()=>{window.scrollTo(0, 0)})

    const buttonLink = css`
      text-decoration: none
    `
    const card = css`
      max-width: 300px;
      transition: 0.3s;
      box-shadow: 0 8px 40px -12px rgba(0, 0, 0, 0.3);

      &:hover {
        box-shadow: 0 16px 70px -12.125px rgba(0, 0, 0, 0.3)
      }

      @media (max-width: 641px) {
        padding-bottom: 5%;
      }
      padding-bottom: 1.5%;
      margin: 2% auto;
    `
    const content = css`
      text-align: left;
    `
    const divider = css`
      padding-bottom: 2%;
    `
    const heading = css`
      font-weight: bold;
    `
    const subheading = css`
      line-height: 1.8
    `
    const estimateText = css`
      font-style: italic;
      line-height: 1.8
    `
    const background = css`
      background: rgb(249, 249, 249);
      background: linear-gradient(180deg, rgba(249, 249, 249, 1) 1%, rgba(32, 116, 212, 1) 100%);
      margin-bottom: -8px;
    `
    const container = css`
      width: 75%;
      padding-top:1%;
      padding-bottom:1%;
      display: inline-block;
    `
    return (
        <div className="App">
            <div className={background}>
                <div className={container}>
                    <Grid container>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    WordPress Basic
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Our basic economical plan for getting a quick website going for any small business.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        3-5 Webpages
                                    </ListItem>
                                    <ListItem>
                                        Contact Feature
                                    </ListItem>
                                    <ListItem>
                                        Budget plan for getting an basic website running quickly
                                    </ListItem>
                                    <ListItem>
                                        Easy to learn and continue development after initial setup, even for beginners
                                    </ListItem>
                                    <ListItem>
                                        Pick your own theme from many styles&nbsp;
                                        <a href="https://en-ca.wordpress.org/themes/" target="_blank"
                                           rel="noopener noreferrer">
                                            here</a>
                                    </ListItem>
                                    <ListItem>
                                        Ideal for a simple website, not requiring any authentication
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                {/*WordPress*/}
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                    height="5em"
                                    width="5em"
                                    style={{marginBottom: '12.5%', marginTop: '2%'}}
                                >
                                    <path
                                        d="M12.633 7.653c0-.848-.305-1.435-.566-1.892l-.08-.13c-.317-.51-.594-.958-.594-1.48 0-.63.478-1.218 1.152-1.218.02 0 .039.002.058.003l.031.003A6.838 6.838 0 008 1.137 6.855 6.855 0 002.266 4.23c.16.005.313.009.442.009.717 0 1.828-.087 1.828-.087.37-.022.414.521.044.565 0 0-.371.044-.785.065l2.5 7.434 1.5-4.506-1.07-2.929c-.369-.022-.719-.065-.719-.065-.37-.022-.326-.588.043-.566 0 0 1.134.087 1.808.087.718 0 1.83-.087 1.83-.087.37-.022.413.522.043.566 0 0-.372.043-.785.065l2.48 7.377.684-2.287.054-.173c.27-.86.469-1.495.469-2.046zM1.137 8a6.864 6.864 0 003.868 6.176L1.73 5.206A6.837 6.837 0 001.137 8z"/>
                                    <path
                                        d="M6.061 14.583L8.121 8.6l2.109 5.78c.014.033.03.064.049.094a6.854 6.854 0 01-4.218.109zm7.96-9.876c.03.219.047.453.047.706 0 .696-.13 1.479-.522 2.458l-2.096 6.06a6.86 6.86 0 002.572-9.224z"/>
                                    <path
                                        fillRule="evenodd"
                                        d="M0 8c0-4.411 3.589-8 8-8 4.41 0 8 3.589 8 8s-3.59 8-8 8c-4.411 0-8-3.589-8-8zm.367 0c0 4.209 3.424 7.633 7.633 7.633 4.208 0 7.632-3.424 7.632-7.633C15.632 3.79 12.208.367 8 .367 3.79.367.367 3.79.367 8z"
                                    />
                                </svg>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "WordPress Basic" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 1 month*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    WordPress Advanced
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Our advanced WordPress plan for medium sized businesses, providing a more in-depth
                                    featured experience.
                                    In addition to the benefits of the basic WordPress package.

                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        5-10+ Webpages
                                    </ListItem>
                                    <ListItem>
                                        Marketplace and order fulfillment
                                    </ListItem>
                                    <ListItem>
                                        Search Engine Optimization (SEO) for bing and Google
                                    </ListItem>
                                    <ListItem>
                                        Optional <a href="https://en-ca.wordpress.org/plugins/" target="_blank"
                                                    rel="noopener noreferrer">
                                        plugins</a> allow for a wider range of possibilities to be built on the
                                        WordPress platform.
                                    </ListItem>
                                    <ListItem>
                                        Ideal for businesses, blogs, and similar to gain awareness and recognition
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <div style={{paddingTop: '2%', paddingBottom: '12%'}}>
                                    {/*WordPress*/}
                                    <svg
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M12.633 7.653c0-.848-.305-1.435-.566-1.892l-.08-.13c-.317-.51-.594-.958-.594-1.48 0-.63.478-1.218 1.152-1.218.02 0 .039.002.058.003l.031.003A6.838 6.838 0 008 1.137 6.855 6.855 0 002.266 4.23c.16.005.313.009.442.009.717 0 1.828-.087 1.828-.087.37-.022.414.521.044.565 0 0-.371.044-.785.065l2.5 7.434 1.5-4.506-1.07-2.929c-.369-.022-.719-.065-.719-.065-.37-.022-.326-.588.043-.566 0 0 1.134.087 1.808.087.718 0 1.83-.087 1.83-.087.37-.022.413.522.043.566 0 0-.372.043-.785.065l2.48 7.377.684-2.287.054-.173c.27-.86.469-1.495.469-2.046zM1.137 8a6.864 6.864 0 003.868 6.176L1.73 5.206A6.837 6.837 0 001.137 8z"/>
                                        <path
                                            d="M6.061 14.583L8.121 8.6l2.109 5.78c.014.033.03.064.049.094a6.854 6.854 0 01-4.218.109zm7.96-9.876c.03.219.047.453.047.706 0 .696-.13 1.479-.522 2.458l-2.096 6.06a6.86 6.86 0 002.572-9.224z"/>
                                        <path
                                            fillRule="evenodd"
                                            d="M0 8c0-4.411 3.589-8 8-8 4.41 0 8 3.589 8 8s-3.59 8-8 8c-4.411 0-8-3.589-8-8zm.367 0c0 4.209 3.424 7.633 7.633 7.633 4.208 0 7.632-3.424 7.632-7.633C15.632 3.79 12.208.367 8 .367 3.79.367.367 3.79.367 8z"
                                        />
                                    </svg>
                                    {/*plus*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <defs>
                                            <style/>
                                        </defs>
                                        <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"/>
                                        <path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"/>
                                    </svg>

                                </div>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "WordPress Advanced" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 1-3 months*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    PhP and JavaScript Website
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Custom built solutions tailored to your needs. Have an idea you'd like to see come
                                    to fruition? Let us know about it.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        3-10+ Webpages
                                    </ListItem>
                                    <ListItem>
                                        Fully featured custom website using the latest technologies
                                    </ListItem>
                                    <ListItem>
                                        Dashboard, administration, corporate portals, chat applications, etc.
                                    </ListItem>
                                    <ListItem>
                                        Versatile, high performance Single Page Applications (SPA) and Server Side
                                        Rendering (SSR)
                                    </ListItem>

                                    <ListItem>
                                        Ideal for a medium to large size project that requires custom built software for
                                        operation.
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <div style={{paddingBottom: '10%'}}>
                                    {/*Laravel*/}
                                    <svg
                                        viewBox="0 0 512 512"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M504.4 115.83a5.72 5.72 0 00-.28-.68 8.52 8.52 0 00-.53-1.25 6 6 0 00-.54-.71 9.36 9.36 0 00-.72-.94c-.23-.22-.52-.4-.77-.6a8.84 8.84 0 00-.9-.68L404.4 55.55a8 8 0 00-8 0L300.12 111a8.07 8.07 0 00-.88.69 7.68 7.68 0 00-.78.6 8.23 8.23 0 00-.72.93c-.17.24-.39.45-.54.71a9.7 9.7 0 00-.52 1.25c-.08.23-.21.44-.28.68a8.08 8.08 0 00-.28 2.08v105.24l-80.22 46.19V63.44a7.8 7.8 0 00-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35 8.35 0 00-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36 9.36 0 00-.72-.94 9.46 9.46 0 00-.78-.6 9.8 9.8 0 00-.88-.68L115.61 1.07a8 8 0 00-8 0L11.34 56.49a6.52 6.52 0 00-.88.69 7.81 7.81 0 00-.79.6 8.15 8.15 0 00-.71.93c-.18.25-.4.46-.55.72a7.88 7.88 0 00-.51 1.24 6.46 6.46 0 00-.29.67 8.18 8.18 0 00-.28 2.1v329.7a8 8 0 004 6.95l192.5 110.84a8.83 8.83 0 001.33.54c.21.08.41.2.63.26a7.92 7.92 0 004.1 0c.2-.05.37-.16.55-.22a8.6 8.6 0 001.4-.58L404.4 400.09a8 8 0 004-6.95V287.88l92.24-53.11a8 8 0 004-7V117.92a8.63 8.63 0 00-.24-2.09zM111.6 17.28l80.19 46.15-80.2 46.18-80.18-46.17zm88.25 60V278.6l-46.53 26.79-33.69 19.4V123.5l46.53-26.79zm0 412.78L23.37 388.5V77.32L57.06 96.7l46.52 26.8v215.18a6.94 6.94 0 00.12.9 8 8 0 00.16 1.18 5.92 5.92 0 00.38.9 6.38 6.38 0 00.42 1 8.54 8.54 0 00.6.78 7.62 7.62 0 00.66.84c.23.22.52.38.77.58a8.93 8.93 0 00.86.66l92.19 52.18zm8-106.17l-80.06-45.32 84.09-48.41 92.26-53.11 80.13 46.13-58.8 33.56zm184.52 4.57L215.88 490.11V397.8l130.72-74.6 45.77-26.15zm0-119.13L358.68 250l-46.53-26.79v-91.42l33.69 19.4L392.37 178zm8-105.28l-80.2-46.17 80.2-46.16 80.18 46.15zm8 105.28V178L455 151.19l33.68-19.4v91.39z"/>
                                    </svg>
                                    <svg
                                        viewBox="0 0 512 512"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"/>
                                    </svg>
                                </div>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "PhP and JavaScript Website" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 3-10 months*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    Search Engine Optimization
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Aren't getting the wanted awareness and search engine rankings out of your current
                                    website?
                                    We have solutions that will increase traffic and reach.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        Compliance with bing and Google search engine regulations
                                    </ListItem>
                                    <ListItem>
                                        Increased search engine average rankings
                                    </ListItem>
                                    <ListItem>
                                        Gather input and analytics on current traffic and behaviours
                                    </ListItem>
                                    <ListItem>
                                        Get insights that can help you market your business to a wider range of viewers
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <div style={{paddingTop: '7%', paddingBottom: '12%'}}>
                                    {/*Bing*/}
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M5.71 3l3.593 1.264v12.645l5.061-2.919-2.48-1.165-1.566-3.897 7.974 2.802v4.073l-8.984 5.183-3.595-2L5.71 3z"/>
                                    </svg>
                                    {/*Google*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z"/>
                                    </svg>
                                </div>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "Search Engine Optimization" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 1 month*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    Android/iOS Basic
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Compatible codebase built in React Native is shared between both Android and iOS.
                                    Simpler to maintain in the post-development stage.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        3-5 Screens
                                    </ListItem>
                                    <ListItem>
                                        Compact code structure
                                    </ListItem>
                                    <ListItem>
                                        Modern design and animation
                                    </ListItem>
                                    <ListItem>
                                        Can be deployed to both iPhone and Android
                                    </ListItem>
                                    <ListItem>
                                        Start with the basic plan and upgrade to the advanced plan when your business
                                        plan develops
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <div style={{paddingBottom: '13%'}}>
                                    {/*Android*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="black"
                                        height="5em"
                                        width="5em"
                                        style={{marginTop: '26%'}}
                                    >
                                        <path
                                            d="M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z"/>
                                    </svg>
                                    {/*iOS*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="black"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"/>
                                    </svg>
                                </div>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "Android/iOS Basic" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 1-3 months*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    Android/iOS Advanced
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    A fully featured React Native application for both Android and iOS. Built for
                                    applications
                                    requiring authentication, marketplace, and more complicated features. In addition to
                                    the
                                    benefits of the basic Android/iOS package.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        5-10+ Screens
                                    </ListItem>
                                    <ListItem>
                                        Node backend with secure features
                                    </ListItem>
                                    <ListItem>
                                        Pair with a website package for an all-around project available to more devices
                                    </ListItem>
                                    <ListItem>
                                        Authentication, in-app payment, marketplace, and more
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <div style={{paddingBottom: '12%'}}>
                                    {/*Android*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="black"
                                        height="5em"
                                        style={{marginTop: '12%'}}
                                        width="5em"
                                    >
                                        <path
                                            d="M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z"/>
                                    </svg>
                                    {/*iOS*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="black"
                                        height="5em"
                                        width="5em"
                                    >
                                        <path
                                            d="M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"/>
                                    </svg>
                                    {/*plus*/}
                                    <svg
                                        viewBox="0 0 1024 1024"
                                        fill="currentColor"
                                        height="5em"
                                        width="5em"
                                    >
                                        <defs>
                                            <style/>
                                        </defs>
                                        <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"/>
                                        <path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"/>
                                    </svg>
                                </div>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "Android/iOS Advanced" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: 3-10 months*
                            </Typography>
                        </Card>
                        <Card className={card}>
                            <CardContent className={content}>
                                <Typography
                                    className={heading}
                                    variant={"h6"}
                                    gutterBottom
                                >
                                    Software Contracting
                                </Typography>
                                <Typography
                                    className={subheading}
                                    style={{textAlign: 'center'}}
                                    variant={"caption"}
                                >
                                    Have an existing codebase that needs more features, updated, or troubleshooted?
                                    Is there something else not listed in our categories that we can provide as a
                                    service? Contact us,
                                    we'd like to discuss potential solutions.
                                </Typography>
                                <Divider className={divider} light/>
                                <Typography
                                    className={subheading}
                                    style={{paddingTop: '2%'}}
                                    variant={"subtitle2"}
                                >
                                    Includes
                                </Typography>
                                <List
                                    sx={{
                                        listStyleType: 'disc',
                                        pl: 2,
                                        '& .MuiListItem-root': {
                                            display: 'list-item',
                                            fontStyle: 'roboto',
                                            fontSize: '0.8rem'
                                        },
                                    }}>
                                    <ListItem>
                                        VoIP
                                    </ListItem>
                                    <ListItem>
                                        Automation
                                    </ListItem>
                                    <ListItem>
                                        Authentication and security
                                    </ListItem>
                                    <ListItem>
                                        Network solutions
                                    </ListItem>
                                    <ListItem>
                                        Custom Software
                                    </ListItem>
                                </List>
                            </CardContent>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                    height="5em"
                                    width="5em"
                                    style={{marginBottom: '12%', marginTop: '16%'}}
                                >
                                    <path
                                        d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 01-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 01.872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 012.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 012.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 01.872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 01-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 01-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 110-5.86 2.929 2.929 0 010 5.858z"/>
                                </svg>
                            </div>
                            <Link to="/contact" className={buttonLink} state={{ subject: "Software Contracting" }} ><Button variant="contained">Request a quote</Button></Link>
                            <br/><br/>
                            <Typography
                                className={estimateText}
                                style={{marginTop: '4%'}}
                                variant={"caption"}
                            >
                                Estimated completion: variable*
                            </Typography>
                        </Card>
                    </Grid>
                    <div style={{fontStyle: 'italic', color: '#f9f9f9', fontSize: '0.5rem'}}>* -
                        Estimates vary based on complexity of the project and cannot be guranteed against unforseen
                        circumstances
                    </div>
                </div>
            </div>
        </div>
    );
}


